"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
exports.__esModule = true;
var buildBigNumber_1 = require("../../libcore/buildBigNumber");
var buildOperation_1 = require("../../libcore/buildAccount/buildOperation");
var reconciliation_1 = require("../../reconciliation");
var account_1 = require("../../account");
var OperationOrderKey = {
    date: 0
};
function buildOriginatedAccount(_a) {
    var core = _a.core, parentAccountId = _a.parentAccountId, currency = _a.currency, coreOriginatedAccount = _a.coreOriginatedAccount, existingOriginatedAccount = _a.existingOriginatedAccount;
    return __awaiter(this, void 0, void 0, function () {
        var balance, _b, address, query, coreOperations, id, operations, swapHistory, originatedAccount;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _b = buildBigNumber_1.libcoreAmountToBigNumber;
                    return [4 /*yield*/, coreOriginatedAccount.getBalance()];
                case 1: return [4 /*yield*/, _b.apply(void 0, [_c.sent()])];
                case 2:
                    balance = _c.sent();
                    return [4 /*yield*/, coreOriginatedAccount.getAddress()];
                case 3:
                    address = _c.sent();
                    return [4 /*yield*/, coreOriginatedAccount.queryOperations()];
                case 4:
                    query = _c.sent();
                    return [4 /*yield*/, query.complete()];
                case 5:
                    _c.sent();
                    return [4 /*yield*/, query.addOrder(OperationOrderKey.date, false)];
                case 6:
                    _c.sent();
                    return [4 /*yield*/, query.execute()];
                case 7:
                    coreOperations = _c.sent();
                    id = "".concat(parentAccountId, "+").concat(address);
                    return [4 /*yield*/, (0, reconciliation_1.minimalOperationsBuilder)((existingOriginatedAccount && existingOriginatedAccount.operations) || [], coreOperations, function (coreOperation) {
                            return (0, buildOperation_1.buildOperation)({
                                core: core,
                                coreOperation: coreOperation,
                                accountId: id,
                                currency: currency,
                                existingAccount: existingOriginatedAccount
                            });
                        })];
                case 8:
                    operations = _c.sent();
                    swapHistory = (existingOriginatedAccount === null || existingOriginatedAccount === void 0 ? void 0 : existingOriginatedAccount.swapHistory) || [];
                    originatedAccount = {
                        type: "ChildAccount",
                        id: id,
                        name: (0, account_1.shortAddressPreview)(address),
                        starred: false,
                        parentId: parentAccountId,
                        currency: currency,
                        address: address,
                        balance: balance,
                        operationsCount: operations.length,
                        operations: operations,
                        pendingOperations: [],
                        creationDate: operations.length > 0
                            ? operations[operations.length - 1].date
                            : new Date(),
                        swapHistory: swapHistory,
                        balanceHistoryCache: {}
                    };
                    originatedAccount.balanceHistoryCache =
                        (0, account_1.generateHistoryFromOperations)(originatedAccount);
                    return [2 /*return*/, originatedAccount];
            }
        });
    });
}
function tezosBuildOriginatedAccount(_a) {
    var core = _a.core, currency = _a.currency, coreAccount = _a.coreAccount, accountId = _a.accountId, existingAccount = _a.existingAccount;
    return __awaiter(this, void 0, void 0, function () {
        var originatedAccounts, xtzAccount, coreOAS, existingAccountByAddress, existingAccountAddresses, _b, _c, existingSubAccount, address, coreOAS_1, coreOAS_1_1, coreOA, address, existingOriginatedAccount, originatedAccount, e_1_1;
        var e_2, _d, e_1, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    originatedAccounts = [];
                    return [4 /*yield*/, coreAccount.asTezosLikeAccount()];
                case 1:
                    xtzAccount = _f.sent();
                    return [4 /*yield*/, xtzAccount.getOriginatedAccounts()];
                case 2:
                    coreOAS = _f.sent();
                    existingAccountByAddress = {};
                    existingAccountAddresses = [];
                    if (existingAccount && existingAccount.subAccounts) {
                        try {
                            for (_b = __values(existingAccount.subAccounts), _c = _b.next(); !_c.done; _c = _b.next()) {
                                existingSubAccount = _c.value;
                                if (existingSubAccount.type === "ChildAccount") {
                                    address = existingSubAccount.address;
                                    existingAccountAddresses.push(address);
                                    existingAccountByAddress[address] = existingSubAccount;
                                }
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_d = _b["return"])) _d.call(_b);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                    }
                    _f.label = 3;
                case 3:
                    _f.trys.push([3, 9, 10, 11]);
                    coreOAS_1 = __values(coreOAS), coreOAS_1_1 = coreOAS_1.next();
                    _f.label = 4;
                case 4:
                    if (!!coreOAS_1_1.done) return [3 /*break*/, 8];
                    coreOA = coreOAS_1_1.value;
                    return [4 /*yield*/, coreOA.getAddress()];
                case 5:
                    address = _f.sent();
                    existingOriginatedAccount = existingAccountByAddress[address];
                    return [4 /*yield*/, buildOriginatedAccount({
                            core: core,
                            parentAccountId: accountId,
                            currency: currency,
                            coreOriginatedAccount: coreOA,
                            existingOriginatedAccount: existingOriginatedAccount
                        })];
                case 6:
                    originatedAccount = _f.sent();
                    if (originatedAccount)
                        originatedAccounts.push(originatedAccount);
                    _f.label = 7;
                case 7:
                    coreOAS_1_1 = coreOAS_1.next();
                    return [3 /*break*/, 4];
                case 8: return [3 /*break*/, 11];
                case 9:
                    e_1_1 = _f.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 11];
                case 10:
                    try {
                        if (coreOAS_1_1 && !coreOAS_1_1.done && (_e = coreOAS_1["return"])) _e.call(coreOAS_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 11:
                    originatedAccounts.sort(function (a, b) {
                        var i = existingAccountAddresses.indexOf(a.address);
                        var j = existingAccountAddresses.indexOf(b.address);
                        if (i === j)
                            return 0;
                        if (i < 0)
                            return 1;
                        if (j < 0)
                            return -1;
                        return i - j;
                    });
                    return [2 /*return*/, originatedAccounts];
            }
        });
    });
}
exports["default"] = tezosBuildOriginatedAccount;
//# sourceMappingURL=libcore-buildSubAccounts.js.map